<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="card">
                    <div class="card-header">Faça login em nossa plataforma</div>
                    <div class="card-body">
                        <form method="post" @submit.prevent="submit()">
                            <div class="row mb-3">
                                <label class="col-md-4 col-form-label text-md-end">E-mail</label>
                                <div class="col-md-6">
                                    <text-input
                                        v-model="form.email" class="form-control"
                                        :error="form.errors.email"
                                        type="email" autocomplete="email" autofocus required/>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <label class="col-md-4 col-form-label text-md-end">Senha</label>
                                <div class="col-md-6">
                                    <text-input
                                        v-model="form.password" class="form-control"
                                        :error="form.errors.password"
                                        type="password" autocomplete="current-password" required/>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-md-6 offset-md-4">
                                    <div class="form-check">
                                        <input v-model="form.remember" class="form-check-input" type="checkbox" id="remember">
                                        <label class="form-check-label" for="remember">
                                            Lembre-me
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-0">
                                <div class="col-md-8 offset-md-4">
                                    <button type="submit" class="btn btn-primary">
                                        Login
                                    </button>

                                    <a class="btn btn-link" href="/password/request">
                                        Esqueceu sua senha?
                                    </a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TextInput from "@/Utils/TextInput"
import {useForm} from '@inertiajs/vue3'

export default {
    props: ['errors','csrf_token'],
    components: {
        TextInput
    },
    setup(props) {
        const form = useForm({
            email: '',
            password: '',
            remember: false,
            _token: props.csrf_token,
        })

        function submit() {
            form.post('/login')
        }

        return {form, submit}
    },
}
</script>

<style scoped>

</style>
